import { IonIcon } from '@ionic/react';
import { arrowForward, eye, handLeft, home } from 'ionicons/icons';
import styles from './TransitDirectionIcon.module.css';

interface TransitDirectionIconProps {
    direction: 'inward' | 'outward' | 'peek-inward' | 'peek-outward' | 'deny-inward' | 'deny-outward';
    className?: string;
    slot?: string;
}

const directionIconMap = {
    inward: home,
    outward: arrowForward,
    'peek-inward': eye,
    'peek-outward': eye,
    'deny-inward': handLeft,
    'deny-outward': handLeft
} as const;

const directionClassNameMap = {
    inward: styles.inward,
    outward: styles.outward,
    'peek-inward': styles.peekInward,
    'peek-outward': styles.peekOutward,
    'deny-inward': styles.denyInward,
    'deny-outward': styles.denyOutward
} as const;

const TransitDirectionIcon: React.FC<TransitDirectionIconProps> = ({ direction, className, slot }) => {
    return (
        <IonIcon
            slot={slot}
            icon={directionIconMap[direction]}
            className={[styles.icon, directionClassNameMap[direction], className].filter(Boolean).join(' ')}
            aria-hidden="true"
        />
    );
};

export default TransitDirectionIcon;
